<template>
  <div>
    <div class="background">
      <div class="shape"></div>
      <div class="shape"></div>
    </div>
    <form action="" autocomplete="off">
      <img :src="pictureImg" class="Login_logo_image" alt="xxxx">
      <label></label>
      <label for="Account">帳號</label>
      <input
        id="Account"
        v-model="Account"
        name="Account"
        placeholder="Account"
        type="text"
        v-on:oninput="limit_input_maxlength"
        maxlength="20"
        autocomplete="off"
      />

      <label for="Password">密碼</label>
      <input
        id="Password"
        v-model="Password"
        name="Password"
        placeholder="Password"
        type="password"
        v-on:oninput="limit_input_maxlength"
        maxlength="20"
        autocomplete="off"
      />

      <label for="verifycode">驗證碼</label>
      <div class="wrap-flex">
        <span class="verify-box" v-if="verifySource != ''">
          <Sidentify
            @refreshCode="refreshCode"
            :verifyCode="verifySource"
          ></Sidentify>
        </span>
        <input
          v-model="verifycode"
          placeholder="請輸入驗證碼"
          v-on:oninput="limit_input_maxlength"
          maxlength="5"
          autocomplete="off"
        />
      </div>
      <div id="div-error-massage" class="div-error-massage">
        <label id="error-massage" class="error-massage">
          {{ error_massage }}
        </label>
      </div>

      <button type="button" @click="login">登入</button>
    </form>
  </div>
</template>

<script>
import Sidentify from "@/components/Sidentify.vue";
import axios from "axios";

export default {
  name: "Login",
  mixins: [],
  components: {
    Sidentify,
  },
  props: [],
  data() {
    return {
      Account: '',
      Password: '',
      verifycode: '',
      // verifySource: 'data:image/png;base64,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',
      verifySource: "",
      error_massage: "",
      api_baseUrl: this.$store.state.api_baseUrl,
      pictureImg: require('@/assets/img/ELC_logo.gif'),
    };
  },
  created() {
    this.refreshCode();
  },
  computed: {},
  mounted() {},
  methods: {
    limit_input_maxlength() {
      if (this.value.length > this.maxLength)
        this.value = this.value.slice(0, this.maxLength);
    },
    refreshCode() {
      let that = this;
      axios.defaults.withCredentials = true; // Set Axios send all cookie by defualt.
      axios
        .get(this.api_baseUrl + "/VerificationCode", {
          headers: {
            "Cache-Control": "no-cache",
          },
          data: true,
        })
        .then((res) => {
          let img_bytes = res.data["verifycode"];
          this.verifySource = "data:image/png;base64," + img_bytes;
        })
        .catch((err) => console.log(err));
    },
    arrayBufferToBase64(buffer) {
      let binary = "";
      let bytes = new Uint8Array(buffer);
      let len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    transData() {
      this.$emit("updateConditions", {
        formNumber: this.formNumber,
        deliveryNumber: this.deliveryNumber,
        shipDate: this.shipDate,
        orderDate: this.orderDate,
        deliveryDate: this.deliveryDate,
        orderPeople: this.orderPeople,
        takePeople: this.takePeople,
        orderType: this.orderType,
        orderStatus: this.orderStatus,
      });
    },
    handleShipStartDateChange(value) {
      this.shipDate.startDate = value;
    },
    handleShipEndDateChange(value) {
      this.shipDate.endDate = value;
    },
    handleOrderStartDateChange(value) {
      this.orderDate.startDate = value;
    },
    handleOrderEndDateChange(value) {
      this.orderDate.endDate = value;
    },
    handleDeliveryStartDateChange(value) {
      this.deliveryDate.startDate = value;
    },
    handleDeliveryEndDateChange(value) {
      this.deliveryDate.endDate = value;
    },
    handleOrderTypeChange(value) {
      this.orderType = value;
    },
    handleOrderStatusChange(value) {
      this.orderStatus = value;
    },
    login() {
      // this.$store.commit("userLogin", true); //Always Login. Just for test.
      let that = this;

      this.$store.commit("resetUserLogin");

      if (that.Account == "" || that.Password == "") {
        that.error_massage = "*帳號密碼不得為空";
      } else if (that.verifycode == "") {
        that.error_massage = "*請輸入驗證碼";
      } else {
        axios
          .post(this.api_baseUrl + "/login", {
            user_account: that.Account,
            user_password: that.Password,
            verification_code: that.verifycode,
          })
          .then((res) => {
            // console.log(res.data);
            let res_status = res.data["Status"];
            if (res_status === "Success") {
              let userdata = {
                flag: true,
                user_id: res.data["user_id"],
                user_name: res.data["user_name"],
                user_account: res.data["user_account"],
                company_id: res.data["company_id"],
                permission: res.data["permission"],
              };
              this.$store.commit("userLogin", userdata);
              this.$router.push("home");
            } else if(res.data["ErrorCode"] === "user004"){
              this.clearLogin();
              alert("登入失敗，使用者無登入權限。錯誤代碼：user004。");
              // console.log('login failed')
              this.refreshCode();
            } else {
              alert("登入失敗，請確認您輸入的帳號密碼及驗證碼是否正確。");
            }
          })
          .catch((err) => {
            this.verifycode = "";
            this.error_massage = "*登入失敗，連線異常";
            alert("登入失敗，連線異常。");
            this.$store.commit("resetUserLogin");
            console.log(err);
          });
      }
    },
    clearLogin(){
      this.Account = "";
      this.Password = "";
      this.verifycode = "";
      this.error_massage = "";
      this.$store.commit("resetUserLogin");
    },
  },
};
</script>

<style scoped lang="scss">
*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.background {
  width: 430px;
  height: 520px;
  position: fixed;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.background .shape {
  height: 200px;
  width: 200px;
  position: fixed;
  border-radius: 50%;
}
.shape:first-child {
  background: linear-gradient(#872bff, #072177);
  left: -80px;
  top: -80px;
}
.shape:last-child {
  background: linear-gradient(to right, #6ffa13, #179035);
  right: -30px;
  bottom: -80px;
}
form {
  height: 570px;
  width: 400px;
  max-width: 100%;
  background-color: rgba(255, 255, 255, 0.13);
  position: fixed;
  transform: translate(-50%, -50%);
  bottom: 0px;
  top: 50%;
  left: 50%;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 40px rgba(8, 7, 16, 0.6);
  padding: 50px 35px;
}
form * {
  font-family: "Poppins", sans-serif;
  color: #ffffff;
  letter-spacing: 0.5px;
  outline: none;
  border: none;
}
form h3 {
  font-size: 32px;
  font-weight: 500;
  line-height: 42px;
  text-align: center;
  color: black;
}

label {
  display: block;
  margin-top: 30px;
  font-size: 16px;
  font-weight: 500;
  color: black;
}
input {
  display: block;
  height: 50px;
  width: 100%;
  background-color: rgba(151, 172, 211, 0.07);
  color: black;
  border-radius: 3px;
  border: 1px solid #d4d4d4; /* Green */
  padding: 0 10px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 300;
}
::placeholder {
  color: #e5e5e5;
}
button {
  margin-top: 50px;
  width: 100%;
  background-color: #fdfdfd;
  color: #080710;
  padding: 15px 0;
  font-size: 18px;
  font-weight: 600;
  border-radius: 5px;
  border: 1px solid #707070; /* Green */
  cursor: pointer;
}

.wrap-flex {
  display: flex;
  justify-content: flex-start;
}

.verify-box {
  margin-top: 9px;
}

#div-error-massage {
  height: 100%;
  max-height: 5px;
  margin-top: -15px;
  margin-bottom: -15px;
}

#error-massage {
  color: red;
  font-weight: bold;
}

.Login_logo_image{
  max-height: 75px;
  height: 30%;
  width: auto;
  margin-top: -15px;
  margin-bottom: -15px;
}
</style>
